// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"117b04de","185":"93953a8f","361":"c22e25d7","418":"7ac36de3","574":"de72af02","788":"e25f541d","881":"a0680d89","919":"5eb6fdff"}[chunkId] + ".chunk.js";
};